

document.addEventListener('DOMContentLoaded', () => {

  function enrolmentCalculator(el) {

    document.querySelector('.filter-results').classList.add('is-loading');

    const data = new URLSearchParams(new FormData(el));
    const url = el.getAttribute('action') ?? window.location.href;

    fetch(url, {
      method: 'post',
      body: data,
    })
    .then(function(response) {
        return response.text();
    })
    .then(function(html) {

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");

        document.querySelector('.filter-results').innerHTML = doc.querySelector('.filter-results').innerHTML;
        document.querySelector('.filter-results').classList.remove('is-loading');

    })
    .catch(function(err) {
        console.log('Failed to fetch page: ', err);
    });

  }

  // calculator search filter
  const enrolmentCalculatorForm = document.getElementById('enrolment-calculator');
  if (enrolmentCalculatorForm) {
    enrolmentCalculatorForm.addEventListener('submit', function(event) {
      enrolmentCalculator(enrolmentCalculatorForm);
      event.preventDefault();
      return false;
    });
  }


});
